import Vue from 'vue'
import Router from 'vue-router'
// 中文PC
import Home from './views/Home.vue'
import pets from './views/pets.vue'
import recommend from './views/recommend.vue'
import aboutUs from './views/aboutUs.vue'
import pc from './views/pc.vue'
import productCenter from './views/productCenter.vue'
import informationCenter from './views/informationCenter.vue'
import commonProblem from './components/informationCenter/commonProblem.vue'
import literature from './components/informationCenter/literature.vue'
import literatureDetail from './components/informationCenter/literatureDetail.vue'
import productCatalog from './components/informationCenter/productCatalog.vue'
import contactUs from './views/contactUs.vue'
import customizedServices from './views/customizedServices.vue'
// 英文PC
import enHome from './ENViews/Home.vue'
import enpets from './ENViews/pets.vue'
import enrecommend from './ENViews/recommend.vue'
import enaboutUs from './ENViews/aboutUs.vue'
import enpc from './ENViews/pc.vue'
import enproductCenter from './ENViews/productCenter.vue'
import eninformationCenter from './ENViews/informationCenter.vue'
import encontactUs from './ENViews/contactUs.vue'
import encustomizedServices from './ENViews/customizedServices.vue'
import encommonProblem from './ENComponents/informationCenter/commonProblem.vue'
import enliterature from './ENComponents/informationCenter/literature.vue'
import enliteratureDetail from './ENComponents/informationCenter/literatureDetail.vue'
import enproductCatalog from './ENComponents/informationCenter/productCatalog.vue'
// 手机端
import phoneAboutUs from './phone/aboutUs.vue'
import phoneContactUs from './phone/contactUs.vue'
import phoneProductCenter from './phone/productCenter.vue'
import phoneRecommend from './phone/recommend.vue'
import phonePet from './phone/pet.vue'
import phoneCustomized from './phone/customized.vue'


Vue.use(Router)
let router = new Router({
    mode: 'history',
    base: process.env.BASE_URL,
    routes: [
        {
            path: '/',
            redirect: '/pc/home'
        },
        {
            path: '/pc',
            name: 'pc',
            component: pc,
            children: [
                {
                    path: 'home',
                    name: 'home',
                    component: Home
                },
                {
                    path: 'pets',
                    name: 'pets',
                    component: pets
                },
                {
                    path: 'recommend',
                    name: 'recommend',
                    component: recommend
                },
                {
                    path: 'about-us',
                    name: 'aboutUs',
                    component: aboutUs
                },
                {
                    path: 'product-center',
                    name: 'productCenter',
                    component: productCenter
                },
                {
                    path: 'information-center',
                    name: 'informationCenter',
                    component: informationCenter,
                    children: [
                        {
                            path: 'product-catalog',
                            name: 'productCatalog',
                            component: productCatalog
                        },
                        {
                            path: 'common-problem',
                            name: 'commonProblem',
                            component: commonProblem
                        },
                        {
                            path: 'literature',
                            name: 'literature',
                            component: literature
                        },
                        {
                            path: 'literature-detail',
                            name: 'literatureDetail',
                            component: literatureDetail
                        }
                    ]
                },
                {
                    path: 'contact-us',
                    name: 'contactUs',
                    component: contactUs
                },
                {
                    path: 'customized-services',
                    name: 'customizedServices',
                    component: customizedServices
                }
            ]
        },
        {
            path: '/pc-en',
            name: 'enpc',
            component: enpc,
            children: [
                {
                    path: 'home',
                    name: 'enhome',
                    component: enHome
                },
                {
                    path: 'pets',
                    name: 'enpets',
                    component: enpets
                },
                {
                    path: 'recommend',
                    name: 'enrecommend',
                    component: enrecommend
                },
                {
                    path: 'about-us',
                    name: 'enaboutUs',
                    component: enaboutUs
                },
                {
                    path: 'product-center',
                    name: 'enproductCenter',
                    component: enproductCenter
                },
                {
                    path: 'information-center',
                    name: 'eninformationCenter',
                    component: eninformationCenter,
                    children: [
                        {
                            path: 'product-catalog',
                            name: 'enproductCatalog',
                            component: enproductCatalog
                        },
                        {
                            path: 'common-problem',
                            name: 'encommonProblem',
                            component: encommonProblem
                        },
                        {
                            path: 'literature',
                            name: 'enliterature',
                            component: enliterature
                        },
                        {
                            path: 'literature-detail',
                            name: 'enliteratureDetail',
                            component: enliteratureDetail
                        }
                    ]
                },
                {
                    path: 'contact-us',
                    name: 'encontactUs',
                    component: encontactUs
                },
                {
                    path: 'customized-services',
                    name: 'encustomizedServices',
                    component: encustomizedServices
                }
            ]
        },
        {
            path: '/phone-contact-us',
            name: 'phoneContactUs',
            component: phoneContactUs,
        },
        {
            path: '/phone-about-us',
            name: 'phoneAboutUs',
            component: phoneAboutUs,
        },
        {
            path: '/phone-product-center',
            name: 'phoneProductCenter',
            component: phoneProductCenter,
        },
        {
            path: '/phone-recommend',
            name: 'phoneRecommend',
            component: phoneRecommend,
        },
        {
            path: '/phone-pet',
            name: 'phonePet',
            component: phonePet,
        },
        {
            path: '/phone-customized',
            name: 'phoneCustomized',
            component: phoneCustomized,
        }
    ],
    scrollBehavior(to, from, saveTop) {
        if (saveTop) {
            return saveTop;
        } else {
            return {x: 0, y: 0}
        }
    },
})
export default router
const originalPush = Router.prototype.push
Router.prototype.push = function push(location) {
    return originalPush.call(this, location).catch(err => err)
}